import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.addEventListener("DOMContentLoaded", async function () {
  // Use a class or data attribute for multiple roots
  const hosts = document.querySelectorAll('.loan-quote-calc-root'); // or use [data-lqc-root]

  hosts.forEach((host) => {
    const formType = host.dataset.formType;
    const shadowRoot = host.attachShadow({ mode: "open" });

    const fontLink = document.createElement("link");
    fontLink.rel = "stylesheet";
    fontLink.href = "https://fonts.googleapis.com/css2?family=Montserrat&display=swap";
    shadowRoot.appendChild(fontLink);
      
      const bootstrapLink = document.createElement("link");
      bootstrapLink.rel = "stylesheet";
      bootstrapLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
      bootstrapLink.crossOrigin = "anonymous";
      shadowRoot.appendChild(bootstrapLink);
    
      const bootstrapVars = document.createElement("style");
      bootstrapVars.textContent = `
        :host, :root {
          --bs-blue: #0d6efd;
          --bs-indigo: #6610f2;
          --bs-purple: #6f42c1;
          --bs-pink: #d63384;
          --bs-red: #dc3545;
          --bs-orange: #fd7e14;
          --bs-yellow: #ffc107;
          --bs-green: #198754;
          --bs-teal: #20c997;
          --bs-cyan: #0dcaf0;
          --bs-black: #000;
          --bs-white: #fff;
          --bs-gray: #6c757d;
          --bs-gray-dark: #343a40;
          --bs-gray-100: #f8f9fa;
          --bs-gray-200: #e9ecef;
          --bs-gray-300: #dee2e6;
          --bs-gray-400: #ced4da;
          --bs-gray-500: #adb5bd;
          --bs-gray-600: #6c757d;
          --bs-gray-700: #495057;
          --bs-gray-800: #343a40;
          --bs-gray-900: #212529;
          --bs-primary: #0d6efd;
          --bs-secondary: #6c757d;
          --bs-success: #198754;
          --bs-info: #0dcaf0;
          --bs-warning: #ffc107;
          --bs-danger: #dc3545;
          --bs-light: #f8f9fa;
          --bs-dark: #212529;
          --bs-primary-rgb: 13, 110, 253;
          --bs-secondary-rgb: 108, 117, 125;
          --bs-success-rgb: 25, 135, 84;
          --bs-info-rgb: 13, 202, 240;
          --bs-warning-rgb: 255, 193, 7;
          --bs-danger-rgb: 220, 53, 69;
          --bs-light-rgb: 248, 249, 250;
          --bs-dark-rgb: 33, 37, 41;
          --bs-primary-text-emphasis: #052c65;
          --bs-secondary-text-emphasis: #2b2f32;
          --bs-success-text-emphasis: #0a3622;
          --bs-info-text-emphasis: #055160;
          --bs-warning-text-emphasis: #664d03;
          --bs-danger-text-emphasis: #58151c;
          --bs-light-text-emphasis: #495057;
          --bs-dark-text-emphasis: #495057;
          --bs-primary-bg-subtle: #cfe2ff;
          --bs-secondary-bg-subtle: #e2e3e5;
          --bs-success-bg-subtle: #d1e7dd;
          --bs-info-bg-subtle: #cff4fc;
          --bs-warning-bg-subtle: #fff3cd;
          --bs-danger-bg-subtle: #f8d7da;
          --bs-light-bg-subtle: #fcfcfd;
          --bs-dark-bg-subtle: #ced4da;
          --bs-primary-border-subtle: #9ec5fe;
          --bs-secondary-border-subtle: #c4c8cb;
          --bs-success-border-subtle: #a3cfbb;
          --bs-info-border-subtle: #9eeaf9;
          --bs-warning-border-subtle: #ffe69c;
          --bs-danger-border-subtle: #f1aeb5;
          --bs-light-border-subtle: #e9ecef;
          --bs-dark-border-subtle: #adb5bd;
          --bs-white-rgb: 255, 255, 255;
          --bs-black-rgb: 0, 0, 0;
          --bs-font-sans-serif: "Montserrat", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
          --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
          --bs-gradient: linear-gradient(180deg, #ffffff26, #fff0);
          --bs-body-font-family: var(--bs-font-sans-serif);
          --bs-body-font-size: 1rem;
          --bs-body-font-weight: 400;
          --bs-body-line-height: 1.5;
          --bs-body-color: #212529;
          --bs-body-color-rgb: 33, 37, 41;
          --bs-body-bg: transparent;
          --bs-body-bg-rgb: 255, 255, 255;
          --bs-emphasis-color: #000;
          --bs-emphasis-color-rgb: 0, 0, 0;
          --bs-secondary-color: #212529bf;
          --bs-secondary-color-rgb: 33, 37, 41;
          --bs-secondary-bg: #e9ecef;
          --bs-secondary-bg-rgb: 233, 236, 239;
          --bs-tertiary-color: #21252980;
          --bs-tertiary-color-rgb: 33, 37, 41;
          --bs-tertiary-bg: #f8f9fa;
          --bs-tertiary-bg-rgb: 248, 249, 250;
          --bs-heading-color: inherit;
          --bs-link-color: #0d6efd;
          --bs-link-color-rgb: 13, 110, 253;
          --bs-link-decoration: underline;
          --bs-link-hover-color: #0a58ca;
          --bs-link-hover-color-rgb: 10, 88, 202;
          --bs-code-color: #d63384;
          --bs-highlight-color: #212529;
          --bs-highlight-bg: #fff3cd;
          --bs-border-width: 1px;
          --bs-border-style: solid;
          --bs-border-color: #dee2e6;
          --bs-border-color-translucent: rgba(0, 0, 0, .175);
          --bs-border-radius: 0.375rem;
          --bs-border-radius-sm: 0.25rem;
          --bs-border-radius-lg: 0.5rem;
          --bs-border-radius-xl: 1rem;
          --bs-border-radius-xxl: 2rem;
          --bs-border-radius-2xl: var(--bs-border-radius-xxl);
          --bs-border-radius-pill: 50rem;
          --bs-box-shadow: 0 0.5rem 1rem #00000026;
          --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, .075);
          --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, .175);
          --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, .075);
          --bs-focus-ring-width: 0.25rem;
          --bs-focus-ring-opacity: 0.25;
          --bs-focus-ring-color: #0d6efd40;
          --bs-form-valid-color: #198754;
          --bs-form-valid-border-color: #198754;
          --bs-form-invalid-color: #dc3545;
          --bs-form-invalid-border-color: #dc3545;
        }
      `;
      shadowRoot.appendChild(bootstrapVars);
    
      const resetStyles = document.createElement("style");
      resetStyles.textContent = `
        *, *::before, *::after {
          box-sizing: border-box;
        }
    
        .lqc {
          margin: 0;
          padding: 0;
          font-family: var(--bs-body-font-family, system-ui, sans-serif);
          background-color: var(--bs-body-bg);
          color: var(--bs-body-color);
        }
    
        .lqc .form-control.is-invalid {
          border: 1px solid var(--bs-form-invalid-border-color);
        }

          .lqc h4 {
              margin-bottom: 20px;
          }

          .lqc .info {
              font-style: italic;
          }

          .lqc .dropdown {
              list-style: none;
              margin: 5px 0;
              padding: 5px;
              border: 1px solid #ccc;
              background: white;
              width: 100%;
              max-height: 150px;
              overflow-y: auto;
              position: absolute;
              z-index: 1000;
          }

          .lqc .dropdown li {
              padding: 8px;
              cursor: pointer;
              border-bottom: 1px solid #eee;
          }

          .lqc .dropdown li .company-number {
              font-style: italic;
              font-size: 14px;
          } 

          .lqc .dropdown li:last-child {
              border-bottom: none;
          }

          .lqc .dropdown li:hover {
              background: #f0f0f0;
          }

          .lqc .form-control {
              width: 100%;
              padding: 8px;
              font-size: 16px;
          }

          .lqc .confirmation-screen {
              padding: 20px;
          }

          .lqc .proceed-btn {
              background: #28a745;
              color: white;
              border: none;
              cursor: pointer;
              margin-right: 10px;
          }

          .lqc .decline-btn {
              border: none;
              cursor: pointer;
          }

          .lqc legend {
              font-size: 16px;
              font-style: italic;
              margin-bottom: 10px;
          }

          .lqc .loading-indicator {
              font-size: 12px;
              font-style: italic;
          }

          .lqc .inner-container {
              max-width: 800px;
              min-width: 200px;
          }

          .lqc .btn-primary {
              min-height: 48px;
              --bs-btn-color: #fff;
              --bs-btn-bg: rgb(8, 44, 102);
              --bs-btn-border-color: rgb(8, 44, 102);
              --bs-btn-hover-color: #fff;
              --bs-btn-hover-bg: rgb(21, 57, 115);
              --bs-btn-hover-border-color: rgb(21, 57, 115);
              --bs-btn-focus-shadow-rgb: 49, 132, 253;
              --bs-btn-active-color: #fff;
              --bs-btn-active-bg: rgb(0, 31, 89);
              --bs-btn-active-border-color: rgb(0, 31, 89);
              --bs-btn-disabled-bg: rgb(0, 31, 89);
              --bs-btn-disabled-border-color: rgb(0, 31, 89);
          }

          .lqc .lqc-form-range::-webkit-slider-thumb {
              background-color: rgb(8, 44, 102) !important;
              border: none;
          }

          .lqc .lqc-form-range::-moz-range-thumb {
              background-color: rgb(8, 44, 102) !important;
              border: none;
          }
      `;
      shadowRoot.appendChild(resetStyles);

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
    shadowRoot.appendChild(script);

    const reactRoot = document.createElement("div");
    shadowRoot.append(reactRoot);

    const root = ReactDOM.createRoot(reactRoot);
    root.render(<App formType={formType} />);
  });
});
